<i [ngClass]="{ open: open }" class="fa fa-chevron-down" aria-hidden="true"></i>
